<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'审核管理'},{name:'债权融资发布审核',goback:true},{name:'债权融资发布审核详情'}]" :title="'债权融资发布审核详情'"/>
            <!-- 主体内容 -->
            <!-- 用户明细 -->
            <div class="box">
               <el-card class="basic box_card" header="账号信息" shadow="never">
                 <el-row>
                  <el-col :span="8" v-if="detail.userVo">
                     <div class="child">
                            <div class="name">账号：</div>
                            <div class="content">{{detail.userVo.userName}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8" v-if="detail.userVo">
                    <div class="child">
                            <div class="name">账号类型：</div>
                            <div class="content">{{detail.userVo.userTypeName}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8" v-if="detail.userVo">
                    <div class="child">
                            <div class="name">姓名：</div>
                            <div class="content">{{detail.createName}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8" v-if="detail.userVo">
                    <div class="child">
                            <div class="name">邮箱：</div>
                            <div class="content">{{detail.userVo.email}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8" v-if="detail.userVo">
                    <div class="child">
                            <div class="name">联系地址：</div>
                            <div class="content">{{detail.userVo.contactAddress}}</div>
                        </div>
                  </el-col>
                  
                </el-row>
              </el-card>
              <el-card class="basic box_card mt16" header="债权产品信息" shadow="never">
                 <el-row>
                  <el-col :span="8" v-if="detail.userVo">
                    <div class="child">
                            <div class="name">银行名称：</div>
                            <div class="content">{{detail.userVo.companyName}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8" v-if="detail.userVo">
                    <div class="child">
                            <div class="name">产品名称：</div>
                            <div class="content">{{detail.debtProductName}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8" v-if="detail.userVo">
                    <div class="child">
                            <div class="name">贷款类型：</div>
                            <div class="content" v-if="detail.loanTypeList && detail.loanTypeList.length > 0">
								<span style="margin-right: 10px;" v-for="(i,index) in detail.loanTypeList" :key="index">{{i}}</span>
							</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">最高额度：</div>
                            <div class="content">{{detail.maxAmount}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">最低额度：</div>
                            <div class="content">{{detail.minAmount}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                   <div class="child">
                            <div class="name">贷款期限：</div>
                            <div class="content" v-if="detail.loanTermBegin || detail.loanTermEnd">
                                <span v-if="detail.loanTermBegin">{{detail.loanTermBegin}}</span><span v-if="detail.loanTermBegin && detail.loanTermEnd">- </span> <span v-if="detail.loanTermEnd">{{detail.loanTermEnd}}</span>(月)</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                   <div class="child">
                            <div class="name">担保方式：</div>
                            <div class="content">{{detail.guaranteeWay}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                   <div class="child">
                            <div class="name">年利率：</div>
                            <div class="content" v-if="detail.yearInterestBegin ||  detail.yearInterestEnd">
                                <span v-if="detail.yearInterestBegin">{{detail.yearInterestBegin}}%</span> <span v-if="detail.yearInterestBegin && detail.yearInterestEnd">-</span> <span v-if="detail.yearInterestEnd">{{detail.yearInterestEnd}}%</span></div>
                        </div>
                  </el-col>
                 </el-row>
                 <el-row>
                  <el-col :span="24">
                   <div class="child">
                            <div class="name">产品介绍：</div>
                            <div class="content super_p" v-html="detail.productIntro"></div>
                        </div>
                  </el-col>
                 </el-row>
                 <el-row>
                  <el-col :span="24">
                   <div class="child">
                            <div class="name">贷款须知：</div>
                            <ul>
                                <li v-for="(item,index) in detail.loanKnown" :key="index" class="content super_ctn" :style="`align-items:${item.content.indexOf('<p') !== -1?'flex-start':'center'}`">
                                    {{index+1}}.<span v-html="item.content" class="super_p" v-if="item.content.indexOf('<p') !== -1"></span><span v-else style="line-height:18px">{{item.content}}</span>
                                </li>
                            </ul>
                        </div>
                  </el-col>
                 </el-row>
                 <el-row>
                  <el-col :span="8">
                   <div class="child">
                            <div class="name">附件：</div>
                            <ul class="content">
                                <li v-for="(item,index) in detail.fileList" :key="index">
                                    <span>{{item.fileName}}</span><i class="el-icon-download" @click="open(item)"></i>
                                </li>
                            </ul>
                        </div>
                  </el-col>
                  
                </el-row>
              </el-card>
              <el-card class="basic box_card mt16" header="审核结果" shadow="never" v-if="tab==='2'">
                <el-row>
                    <el-col :span="8">
                      <div class="child">
                              <div class="name">审核结果：</div>
                              <div class="content">{{detail.checkStatusValue}}</div>
                          </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">审核账号：</div>
                            <div class="content">{{detail.modifyUserName}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">审核时间：</div>
                            <div class="content">{{detail.updateTime}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{detail.checkExplanation}}</div>
                        </div>
                    </el-col>
                  </el-row>
              </el-card>
              
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
import {onDownload} from "@/utils/common";
export default {
    components:{
        breadcrumb
    },
    data(){
        return{
            tab:'1',//选项卡
            id:'',//详情id
            detail:{
               createUserName: "", //账号
                    createName: "",//姓名
                    debtProductName: "",//产品名称
                    loanTypeValue: "",//贷款类型
                    maxAmount: "",//最高额度
                    minAmount: "",//最低额度
                    loanTerm: "",//贷款期限
                    guaranteeWay: "",//担保方式
                    fileList: [],//附件列表
                    yearInterest: '',//年利率
                    productIntro: "",//产品介绍
                    createName: "",//发布账号
                    createTime: "",//发布时间
                    modifyName: "",//发布账号
                    updateTime: "",//发布账号
                    checkStatusValue: '',//审核状态
                    modifyUserName: "",//审核账号
                    updateDate: '',//审核时间
                    checkExplanation: "",//说明
                    loanKnown: [],
                    userVo: {
                        email: "",//邮箱
                        contactAddress: "",//联系地址
                        companyName: "",
                        userName: "",//用户名
                        userTypeName: "",//用户类型
                    }
            },//数据
			debtStatistics:'',//债权融资统计
			financialLeasingStatistics:'',//融资租赁统计
			equityStatistics:'',//股权融资列表统计
			vouchStatistics:'',//担保服务统计
			policyGuidanceStatistics:'',//政策指引统计
			incubatorStatistics:'',//孵化器统计
			activitySalonStatistics:'',//活动沙龙统计
        }
    },
    methods:{
        open({fileName,filePath}){
            const formData = new window.FormData()
          formData.append('fileName', filePath)
          onDownload(formData,fileName)
        },
        //获取数据
        async getData(){
         const {code,data,msg} = await this.$axiosc.get('backstage/debt/financing/reviewLog/details/' + this.id)
          if (code == 200) {            
              this.detail = data;
              let value = []
              this.detail.guaranteeWay.map(val => {
                  value.push(val.value)
              })
              this.detail.guaranteeWay = value.join('/')
          } else {
              this.$alert(msg)
          }
        }
    },
    created(){
        this.tab=this.$route.params.type
        this.id=this.$route.query.id;
    },
    mounted(){
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
.warp{
  height:100%;
  overflow: hidden;
}
.box{
  height: calc(100% - 40px);
    overflow-x: hidden;
    overflow-y: auto;
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
}
.basic{
  color:$font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  // background: #fff;
  .el-col{
    margin: 10px 0;
  }
  .child{
    color:#595959;
  }
}
.main{
  background: transparent !important;
  padding:0 !important;
}
.super_ctn{
    display: flex;
    align-items: flex-start;
  }
</style>